import React from "react";
import GameCard from "../components/GameCard";
const GAMES = require("../data/games.json");

function HeroBanner() {
    const top_game = Object.values(GAMES).sort((a, b) => b.rating - a.rating)[0];
    return (
        <div className="relative bg-gradient-to-b from-[#f59e0b] via-[#fbbf24] to-[#fcd34d] overflow-hidden rounded-b-3xl border-b-2 border-white/40 shadow-2xl shadow-[#fbbf24]/30">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    <div>
                        <h1 className="text-4xl md:text-5xl font-extrabold text-[#78350f] mb-2 drop-shadow-lg">TipTide Games</h1>
                        <div className="w-20 h-1 bg-gradient-to-r from-white via-[#fffbeb] to-white mb-4 rounded-full shadow-lg shadow-white/50"></div>
                        <p className="mt-4 text-[#78350f] max-w-xl text-justify leading-relaxed">TipTide Games is a creative mobile game developer and publisher focused on delivering engaging, high-quality entertainment experiences for global audiences. With a passion for innovation and player satisfaction, TipTide Games specializes in designing fun, accessible, and visually appealing titles that combine strong gameplay with cultural and emotional depth. The studio's mission is to connect players through memorable gaming moments while supporting talented developers to bring their ideas to life.</p>
                        <div className="mt-6 flex gap-3">
                            {/* <Link to="/" className="px-4 py-2 rounded-full bg-blue-600 hover:bg-blue-700">Browse games</Link>
                            <a href="#" className="px-4 py-2 rounded-full border border-white/10">Upload game</a> */}
                        </div>
                    </div>
                    {/* <Link to= className="group block bg-gradient-to-br from-[#021428] to-[#011428] rounded-xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition"> */}
                    <div className="hidden sm:block">
                        <div className="bg-gradient-to-br from-white/30 via-[#fffbeb]/40 to-white/30 p-4 rounded-2xl shadow-2xl border-2 border-white/60 backdrop-blur-sm">
                            <img src="/images/hero-banner.png" alt="preview" className="w-full object-cover rounded-md" />
                            <div className="mt-3 text-[#78350f] font-semibold text-center">Discover the Future of Mobile Gaming</div>
                            <div className="text-[#92400e] text-sm text-center">★ ★ ★</div>
                        </div>
                    </div>
                    {/* </Link> */}
                </div>
            </div>
        </div>
    );
}

function Home() {
    return (
        <div className="pt-20 pb-24">
            <HeroBanner />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <section className="mt-12">
                    <h2 className="text-2xl font-semibold text-[#78350f] mb-2">Popular Games</h2>
                    <p className="text-[#92400e] mt-2">Discover and download top mobile titles — curated picks every week.</p>

                    <div className="mt-6 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-6">
                        {Object.values(GAMES).map((g) => (
                            <GameCard key={g.id} game={g} />
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
}

export default Home;